import { CaretRightIcon } from '@bloomfieldrobotics/canopy';
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const StyledText = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 600,
  lineHeight: '142%',
  textTransform: 'capitalize',
});

type Props = {
  customPaths?: {
    path: string;
    label: string;
  }[];
};

/**
 * Breadcrumbs display and navigation for the current location
 */
export const Breadcrumbs = ({ customPaths }: Props) => {
  const location = useLocation();

  let paths: string[];
  if (customPaths) {
    paths = customPaths.map((item) => item.path);
  } else {
    paths = location.pathname.split('/');
  }

  const breadcrumbs = paths.map((path, index) => {
    if (!path) {
      return null;
    }

    const route = paths.slice(0, index + 1).join('/');

    if (index === paths.length - 1) {
      return (
        <StyledText key={route} color='textPrimary'>
          {customPaths?.at(index)?.label ?? path}
        </StyledText>
      );
    }

    return (
      <Link
        key={route}
        underline='none'
        sx={{ color: 'inherit' }}
        component={RouterLink}
        to={route}
      >
        <StyledText>{customPaths?.at(index)?.label ?? path}</StyledText>
      </Link>
    );
  });

  return (
    <Stack
      direction='row'
      sx={(theme) => ({
        alignItems: 'center',
        color: theme.palette.text.secondary,
        gap: 2,
      })}
    >
      <MuiBreadcrumbs separator={<CaretRightIcon fontSize='small' />}>
        {breadcrumbs}
      </MuiBreadcrumbs>
    </Stack>
  );
};
